import React, { useState, useEffect } from 'react';

const FollowUpReminder = ({ onReminder }) => {
  const [reminders, setReminders] = useState([]);

  useEffect(() => {
    // Check for follow-up reminders every minute
    const checkReminders = () => {
      const now = new Date();
      const followUps = JSON.parse(localStorage.getItem('crm-followups') || '[]');
      
      followUps.forEach(followUp => {
        if (followUp.status === 'pending') {
          const scheduledTime = new Date(followUp.scheduledDate);
          const timeDiff = scheduledTime.getTime() - now.getTime();
          
          // Check if we need to send reminders
          const reminderTimes = [
            { time: 24 * 60 * 60 * 1000, label: '24 hours', sent: followUp.reminder24h },
            { time: 2 * 60 * 60 * 1000, label: '2 hours', sent: followUp.reminder2h },
            { time: 30 * 60 * 1000, label: '30 minutes', sent: followUp.reminder30m },
            { time: 15 * 60 * 1000, label: '15 minutes', sent: followUp.reminder15m }
          ];

          reminderTimes.forEach(reminder => {
            if (timeDiff <= reminder.time && timeDiff > 0 && !reminder.sent) {
              // Send reminder
              const reminderData = {
                id: `${followUp.id}-${reminder.label}`,
                followUpId: followUp.id,
                leadName: followUp.leadName,
                leadCompany: followUp.leadCompany,
                type: followUp.type,
                scheduledDate: followUp.scheduledDate,
                timeLeft: reminder.label,
                priority: followUp.priority,
                notes: followUp.notes
              };

              onReminder(reminderData);

              // Mark this reminder as sent
              const updatedFollowUps = followUps.map(f => {
                if (f.id === followUp.id) {
                  return {
                    ...f,
                    [`reminder${reminder.label.replace(' ', '').replace('hours', 'h').replace('minutes', 'm')}`]: true
                  };
                }
                return f;
              });

              localStorage.setItem('crm-followups', JSON.stringify(updatedFollowUps));
            }
          });

          // Check if follow-up is overdue
          if (timeDiff < 0 && !followUp.overdueNotified) {
            const overdueReminder = {
              id: `${followUp.id}-overdue`,
              followUpId: followUp.id,
              leadName: followUp.leadName,
              leadCompany: followUp.leadCompany,
              type: followUp.type,
              scheduledDate: followUp.scheduledDate,
              timeLeft: 'overdue',
              priority: 'high',
              notes: followUp.notes,
              isOverdue: true
            };

            onReminder(overdueReminder);

            // Mark as overdue notified
            const updatedFollowUps = followUps.map(f => {
              if (f.id === followUp.id) {
                return { ...f, overdueNotified: true };
              }
              return f;
            });

            localStorage.setItem('crm-followups', JSON.stringify(updatedFollowUps));
          }
        }
      });
    };

    // Check immediately and then every minute
    checkReminders();
    const interval = setInterval(checkReminders, 60000); // Check every minute

    return () => clearInterval(interval);
  }, [onReminder]);

  return null; // This component doesn't render anything
};

export default FollowUpReminder;
